import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

/**
 * Warns the user that their session is about to expire and lets them keep it
 * alive (a single /auth/me keepalive extends the server session) or log out now.
 *
 * Modeled on the svc-video session-expiry dialog. Driven by SessionManager,
 * which computes `minutesRemaining` from the session expiry timestamp returned
 * by /auth/me.
 */
const SessionExpiryDialog = ({ open, minutesRemaining, onStayLoggedIn, onLogout }) => {
  const { t } = useTranslation(["auth"]);
  const body =
    typeof minutesRemaining === "number"
      ? t("auth:sessionExpiry.bodyWithMinutes", { count: Math.max(1, Math.round(minutesRemaining)) })
      : t("auth:sessionExpiry.bodySoon");

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>{t("auth:sessionExpiry.title")}</DialogTitle>
      <DialogContent>
        <Typography>{body}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="inherit">
          {t("auth:sessionExpiry.logoutButton")}
        </Button>
        <Button onClick={onStayLoggedIn} variant="contained" color="primary">
          {t("auth:sessionExpiry.stayLoggedInButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiryDialog;
